<template>
  <ubi-page-container>
    <ubi-panel>
    <h3>{{$t('socialReviews.autoAnswers.title')}}</h3>
      <el-tag style="margin-top: 10px;margin-bottom: -25px;">{{$t('socialReviews.autoAnswers.subtitle')}}</el-tag>
    </ubi-panel>

    <ubi-panel>
      <h3 style="margin-top: -15px">{{$t('socialReviews.autoAnswers.rate')}} : 1 &#11088;</h3>
      {{$t('socialReviews.autoAnswers.noAutoAnswer')}}<br>
      <el-button type="primary" style="margin-top: 15px;margin-bottom: -25px">{{$t('socialReviews.autoAnswers.edit')}}</el-button>
    </ubi-panel>
    <ubi-panel>
      <h3 style="margin-top: -15px">{{$t('socialReviews.autoAnswers.rate')}} : 2 &#11088;&#11088;</h3>
      {{$t('socialReviews.autoAnswers.noAutoAnswer')}}<br>
      <el-button type="primary" style="margin-top: 15px;margin-bottom: -25px">{{$t('socialReviews.autoAnswers.edit')}}</el-button>
    </ubi-panel>
    <ubi-panel>
      <h3 style="margin-top: -15px">{{$t('socialReviews.autoAnswers.rate')}} : 3 &#11088;&#11088;&#11088;</h3>
      {{$t('socialReviews.autoAnswers.noAutoAnswer')}}<br>
      <el-button type="primary" style="margin-top: 15px;margin-bottom: -25px">{{$t('socialReviews.autoAnswers.edit')}}</el-button>
    </ubi-panel>
    <ubi-panel>
      <h3 style="margin-top: -15px">{{$t('socialReviews.autoAnswers.rate')}} : 4 &#11088;&#11088;&#11088;&#11088;</h3>
      {{$t('socialReviews.autoAnswers.noAutoAnswer')}}<br>
      <el-button type="primary" style="margin-top: 15px;margin-bottom: -25px">{{$t('socialReviews.autoAnswers.edit')}}</el-button>
    </ubi-panel>
    <ubi-panel>
      <h3 style="margin-top: -15px">{{$t('socialReviews.autoAnswers.rate')}} : 5 &#11088;&#11088;&#11088;&#11088;&#11088;</h3>
      {{$t('socialReviews.autoAnswers.noAutoAnswer')}}<br>
      <el-button type="primary" style="margin-top: 15px;margin-bottom: -25px">{{$t('socialReviews.autoAnswers.edit')}}</el-button>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer'
import UbiPanel from '@/components/Panel'
export default {
  components: { UbiPanel, UbiPageContainer }
}
</script>

<style scoped>
  .el-card__body {
    padding: 25px;
  }
</style>
